// List Component
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactDom from 'react-dom'
import ScrollMagic from 'scrollmagic'
import ListCell from '../ListCell/ListCell.jsx'
import Loader from '../../ui/common/common/loader/loader.jsx'
import Footer from './Footer.jsx'
import Header from './Header.jsx'
import Rows from './Rows.jsx'

class List extends Component {
  _scrollObj = null
  _references = {
    loader: React.createRef()
  }

  static propTypes = {
    showLoader: PropTypes.bool,
    objectList: PropTypes.array,
    footerObject: PropTypes.object,
    columns: PropTypes.array,
    renderCustomCell: PropTypes.func.isRequired,
    onRenderFooter: (props, propName, componentName) => {
      if (props.footerObject) {
        if (!props[propName]) {
          return new Error(
            `Prop '${propName}' was not supplied to ${componentName}. It is required when 'footerObject' is supplied.`
          )
        } else if (typeof props[propName] !== 'function') {
          return new Error(
            `Invalid prop '${propName}' supplied to ${componentName}. Type is ${typeof props[
              propName
            ]} and expected 'function'.`
          )
        }
      }
    },
    onPaginate: PropTypes.func,
    actionIcon: PropTypes.string,
    sort: PropTypes.string,
    sortAsc: PropTypes.bool,
    onSort: PropTypes.func,
    onView: PropTypes.func,
    onSettings: PropTypes.func
  }

  static defaultProps = {
    showLoader: false,
    objectList: [],
    footerObject: null,
    columns: [],
    renderCustomCell: null,
    onRenderFooter: null,
    onPaginate: null,
    actionIcon: null,
    sort: null,
    sortAsc: true,
    onSort: null,
    onView: null,
    onSettings: null
  }

  componentDidMount () {
    if (this.props.onPaginate) {
      this._initLoadOnScroll()
    }
  }

  render () {
    const { footerObject, columns, sort, onSort, sortAsc, showLoader, actionIcon, objectList } = this.props

    return (
      <div className='common-list'>
        <div className='listcontwrap'>
          <Header
            columns={columns}
            sortIdentifier={sort}
            sortAsc={sortAsc}
            onCellClick={onSort ? this.handleSort : null}
          />
          <div className='listcont'>
            <Rows
              actionIcon={actionIcon}
              objectList={objectList}
              onActionClick={this.handleSettingsClick}
              renderContent={this.renderContentColumns}
            />
            {footerObject && <Footer>{this.renderContentColumns(footerObject, true)}</Footer>}
          </div>
        </div>
        <Loader ref={this._references.loader} hidden={!showLoader} />
      </div>
    )
  }

  /* Event Handlers */
  handleSort = identifier => {
    const sortAsc = this.props.sort === identifier ? !this.props.sortAsc : true
    this.props.onSort && this.props.onSort(identifier, sortAsc)
  }

  handleCellClick = (obj, col) => this.props.onView && this.props.onView(obj, col)

  handleSettingsClick = obj => this.props.onSettings && this.props.onSettings(obj)

  renderContentColumns = (obj, bIsFooter) => {
    return this.props.columns.map((col, idx) => {
      if (col.type === 'custom') {
        if (bIsFooter) {
          return this.props.onRenderFooter(obj, col, idx)
        }
        return this.props.renderCustomCell(obj, col, idx)
      }

      let value = obj[col.identifier]
      if (col.field && obj[col.field]) {
        value = obj[col.field][col.identifier]
      }

      // If the label is value of projectNumber is empty display the project title
      if (col.label === 'invoice.list.labelProjectNumber') {
        if (value === '') {
          value = '-'
        }
      }

      return (
        <ListCell
          key={idx}
          value={value}
          defaultValue={bIsFooter ? '' : '-'}
          type={col.type}
          width={col.width}
          formatProgressOverdue={col.formatOverdue || false}
          onClick={this.handleCellClick.bind(this, obj, col)}
        />
      )
    })
  }

  _initLoadOnScroll () {
    const controller = new ScrollMagic.Controller()
    this._scrollObj = new ScrollMagic.Scene({
      triggerElement: ReactDom.findDOMNode(this._references.loader.current),
      triggerHook: 'onEnter'
    })
      .addTo(controller)
      .on('enter', () => {
        if (this._references.loader.current && !this._references.loader.current.state.active) {
          this._references.loader.current.makeActive()
          window.setTimeout(() => {
            this._loadMoreData()
          }, 1000)
        }
      })
  }

  _loadMoreData () {
    if (this._references.loader.current) {
      this._references.loader.current.makeInActive()
    }

    if (this._scrollObj) {
      this._scrollObj.update()
      this.props.onPaginate()
    } else {
      this._destroyLoadOnScroll()
    }
  }

  _destroyLoadOnScroll () {
    if (this._scrollObj) {
      this._scrollObj.destroy()
      this._scrollObj = null
    }
  }
}

export default List
